import styled from "styled-components";

export const WrapperTitle = styled.div`
  background-color: ${({ theme }) => theme.backgroundSidebar};
  padding: 1rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  margin: 1rem 0;
  box-shadow: rgb(0 0 0 / 16%) 0px 3px 6px, rgb(0 0 0 / 23%) 0px 3px 6px;
`;

export const MainContent = styled.div`
  /* background-color: ${({ theme }) => theme.backgroundSidebar}; */
`;
